export default __webpack_public_path__ + "static/media/map-element-2-pink.3696931e.svg";